var api = {
  // user
  register: '/auth/account/register',
  Login: '/auth/account/login',
  verificationCode: '/auth/account/verificationCode',
  forgotPassword: '/auth/account/forgotPassword',
  verifyPassword: '/auth/account/verifyPassword',
  userName: '/user/account/userName',
  getCountry: '/user/country/list ',
  // vehicleControl
  unbind: '/vehicle/unbind',
  // MG,
  userCheck: '/apiv3/users/app/h5.check',
  userRegister: '/apiv3/users/app/h5.register',
  userInfo: '/apiv3/user',
  threadList: '/apiv3/thread.list',
  topicList: '/apiv3/topics.list',
  detail: '/apiv3/thread.detail',
  comments: '/apiv3/posts',
  follow: '/apiv3/follow',
  unFollow: '/apiv3/follow.delete',
  signalTopicList: '/apiv3/topics.list',
  postComments: '/apiv3/posts',
  thumbs: '/apiv3/posts.update',
  signalComment: '/apiv3/posts.detail',
  banner: '/api/backAdmin/banner.list',
  categories: '/apiv3/categories',
  categoriesBind: '/apiv3/categories.bind',
  myCategories: '/apiv3/categories.me',
  topicCreate: '/apiv3/topic.create',
  activityList: '/apiv3/activity.list',
  activityDetail: '/apiv3/activity.detail',
  recommendKeywords: '/api/backAdmin/recommend.keywords.list',
  uploadImg: '/apiv3/attachments',
  post: '/apiv3/thread.create',
  collect: '/apiv3/threads/operate',
  signUp: '/apiv3/activity.registration',
  paperList: '/apiv3/question.list',
  // paperList: '/api/backAdmin/question.lis',
  paperDetail: '/apiv3/question.detail',
  questionList: '/apiv3/question.chapter.detail',
  answerQuestion: 'apiv3/question.answer',
  message: 'apiv3/unreadnotification',
  noticeList: 'apiv3/notification',
  followList: 'apiv3/follow',
  userInfoModify: 'apiv3/users/update.user',
  threadDelete: 'apiv3/thread.delete',
  share: 'apiv3/user.share',
  updateInfo: 'apiv3/users/nickname.set',
  getJoinNum: '/apiv3/activity/nums'
};
export default api;